import { updateWowPath, getPathInfo, useWowPath } from "../hooks/path-hooks";
import { validParams } from "./valid_parameters";

export function getValidParamKeys(page) {
  const validPageParams = validParams[page] || {};
  const validKeys = {};

  Object.keys(validPageParams).forEach((key) => {
    if (key === "exemptions") {
      validPageParams["exemptions"].forEach((exemption) => {
        validKeys[exemption] = true;
      });
    } else if (key !== "default") {
      validKeys[key] = true;
    }
  });

  return validKeys;
}

/**
 * @param {object} queryParams - Query parameters to validate
 * @param {string} page - Page type to get valid param options
 * @param {string} queryParamType - Set of valid parameters (Champions or Player Profile)
 * @param {boolean} keepDefaultParams - Set to true if default params should be kept
 */
// Removes params with invalid keys or values
export function useValidateQueryParams() {}

export function validateFilter(currentFilter, page, pathname) {
  const { encounterType } = getPathInfo(pathname);
  const options = validParams[page];
  // Add this line back if we have multiple raids
  // const raid = "dungeon" in currentFilter && currentFilter["dungeon"];
  const current_encounter = "encounter" in currentFilter && currentFilter["encounter"];
  let newFilter = currentFilter;

  if (encounterType == "mythic") {
    delete newFilter["difficulty"];
    delete newFilter["dungeon"];
  }

  if (current_encounter) {
    const dungeonProp =
      // Add this line back if we have multiple raids
      // encounterType == "mythic" ? options.mythics : raid in options.encounters ? options.encounters[raid] : undefined;
      encounterType === "mythic" ? options.mythics : options.encounters.venomous_abyss;
    const isValidDungeon =
      dungeonProp &&
      dungeonProp.some((encounter) => {
        return encounter.value == current_encounter;
      });
    if (!isValidDungeon) {
      delete newFilter["encounter"];
    }
  }

  return newFilter;
}

export function validatePathname(pathname, page) {
  const options = validParams[page];
  let { classType: selectedClass, specType, encounterType } = getPathInfo(pathname);

  // C: Have to change mythic to empty string since mythic is now not in the path
  if (encounterType === "mythic") {
    encounterType = "";
  }

  const isValidSpec = options.specs[selectedClass].some((spec) => {
    return spec.value == specType;
  });

  if (page === "pvp") {
    return updateWowPath(pathname, {
      specType: isValidSpec ? null : options.specs[selectedClass][0].value,
    });
  }

  const isValidEncounterType = options.encounterTypes?.some((option) => option.type.replace(/\+/g, "") == encounterType);

  return updateWowPath(pathname, {
    specType: isValidSpec ? null : options.specs[selectedClass][0].value,
    encounterType: isValidEncounterType ? null : options.encounterTypes[0],
  });
}
